import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bce4e2d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "team-card style1" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "team-overlay" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "team-info text-center mt-3" }
const _hoisted_9 = { class: "truncate-text" }
const _hoisted_10 = { class: "team-designation" }
const _hoisted_11 = { class: "mt-4" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "modal-info" }
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-3 col-lg-4 col-md-6",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "team-img",
                style: _normalizeStyle({
                height: '250px',
                backgroundImage: `url(${_ctx.getUrlApiForFiles(article.image)})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                borderRadius: '10px',
                cursor: 'pointer'
              }),
                onClick: ($event: any) => (_ctx.openModal(article))
              }, _hoisted_7, 12, _hoisted_5),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h4", _hoisted_9, _toDisplayString(article.titre), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formatDate(article.datePublication)), 1)
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ]),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "photo-modal",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createElementVNode("div", {
            class: "modal-content",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("span", {
              class: "close-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, "×"),
            _createElementVNode("img", {
              src: _ctx.getUrlApiForFiles(_ctx.selectedArticle.image),
              alt: _ctx.selectedArticle.titre
            }, null, 8, _hoisted_12),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.selectedArticle.titre), 1),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.formatDate(_ctx.selectedArticle.datePublication)), 1),
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.selectedArticle.contenu), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}